<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменение заказа
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      Не могу отобразить изменения, тип события не определен...
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'

  export default {
    name: 'HistoryItemDefault',
    components: { UserInfoLabel, Avatar },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {

      }
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
